import { images } from './constants';
import { type Club } from './types';

export const getClubImage = (club: Club) => {
  return images[club];
};
